/* eslint-disable react/no-array-index-key */
import { Grid, Skeleton, styled } from '@mui/material';

const StyledGrid = styled(Grid)({
  justifyContent: 'space-between',
  bgcolor: '#FFF',
  borderRadius: 2,
  boxShadow: '0px 4px 40px 0px rgba(255, 221, 200, 0.25)',
  padding: '32px',
  gap: '20px',
});

const SingleLoadingDiv = () => (
  <StyledGrid container>
    <Skeleton variant="rounded" animation="wave" height={28} width={26} />
    <Skeleton animation="wave" height={22} sx={{ flexGrow: 1 }} />
    <Skeleton variant="rectangular" animation="wave" height={24} width={5} />
  </StyledGrid>
);

export const ActivityLibraryFoldersLoadingView = () => (
  <Grid container spacing={2.5}>
    {[...Array(6)].map((_, index) => (
      <Grid key={index} item xs={4}>
        <SingleLoadingDiv />
      </Grid>
    ))}
  </Grid>
);

export const ActivityLibrarySearchBarLoadingView = () => (
  <StyledGrid container p={3} mt={3.5}>
    <Skeleton variant="rounded" animation="wave" height={28} sx={{ flexGrow: 5 }} />
    <Skeleton variant="rounded" animation="wave" height={30} sx={{ flexGrow: 1 }} />
    <Skeleton variant="rounded" animation="wave" height={30} sx={{ flexGrow: 1.5 }} />
  </StyledGrid>
);

export const SingleFolderSearchBarLoadingView = () => (
  <StyledGrid container p={3} mt={3.5}>
    <Skeleton variant="rounded" animation="wave" height={28} sx={{ flexGrow: 5 }} />
    <Skeleton variant="rounded" animation="wave" height={30} sx={{ flexGrow: 1.5 }} />
  </StyledGrid>
);
